import { Routes, Route } from "react-router-dom";
import Site2Home from "./Screens/Site2/Site2Home";
import Site2Services from "./Screens/Site2/Site2Services";
import Site2Vision from "./Screens/Site2/Site2Vision";
import Site2Activity from "./Screens/Site2/Site2Activity";
import Site2Contact from "./Screens/Site2/Site2Contact";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Site2Home />} />
      <Route path="/services" element={<Site2Services />} />
      <Route path="/vision" element={<Site2Vision />} />
      <Route path="/activity" element={<Site2Activity />} />
      <Route path="/contact" element={<Site2Contact />} />

      {/* Backward compatible /site2/* aliases */}
      <Route path="/site2" element={<Site2Home />} />
      <Route path="/site2/services" element={<Site2Services />} />
      <Route path="/site2/vision" element={<Site2Vision />} />
      <Route path="/site2/activity" element={<Site2Activity />} />
      <Route path="/site2/contact" element={<Site2Contact />} />
    </Routes>
  );
}

export default App;
